import React from "react";

export default function ContentQuestionTags({ tags = [] }) {
    if (!tags.length) {
        return null;
    }

    return (
        <div className="cq-tags">
            {tags.map((tag) => (
                <span key={tag} className="cq-tag">{tag}</span>
            ))}
        </div>
    );
}
